var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{staticClass:"idtr-field",attrs:{"rules":_vm.rules,"name":_vm.name,"mode":"lazy","tag":"span"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('input',{directives:[{name:"maska",rawName:"v-maska"}],class:[
      'idtr-input',
      {
        'idtr-input--error': errors.length,
        'idtr-input--bold': _vm.bold,
        'idtr-input--inline': _vm.inline,
      },
    ],style:(_vm.width ? { width: _vm.width } : null),attrs:{"id":_vm.id || null,"data-maska":_vm.maskaAttr,"placeholder":_vm.placeholder,"maxlength":_vm.maxlength || null,"spellcheck":"false","autocomplete":"off"},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }